export const getEnv = (key) => {
    return window.env[key];
  };